import jwt from '@credlock-x/jwt-node'

export const signed = (opts) => {
  const data = JSON.parse(opts.body)

  return {
    id: data.id,
    operator_id: data.operator_id,
    membership_id: data.membership_id,
    document_id: data.document_id,
    status: 'signed',
    external_id: 233453,
    external_url: 'https://docuseal.eu/blobs/proxy/eyJfcmFpbHMiOnsib/sample-document.pdf',
    signed_at: new Date(),
    submission: {
      event_type: 'form.completed',
      timestamp: Date.now().toString(),
      data: {
        id: 123,
        email: 'test.user@dummy.moc',
        completed_at: Date.now().toString(),
        role: 'First Party',
        external_id: data.membership_id,
        status: 'completed',
        submission: {
          id: data.submission_id,
          status: 'completed',
          url: 'https://docuseal.eu/e/N5JsdkFGPeQF7J',
          created_at: Date.now().toString(),
        },
        template: {
          id: 418956,
          name: 'H&S Acceptance',
        },
      },
    },
  }
}

export const token = (membership) => {
  // get access-token for signing document
  const data = {
    user_email: 'test.user@dummy.moc',
    integration_email: 'documents@evo.test',
    external_id: membership.id,
    name: 'Annie Body',
    template_id: 492487,
    exp: Date.now() + 3600000,
  }
  const secret = 'd8JnvaEPoFoZpvrrsxDRE28ksrj3ZA3pBMswMiiWEpU'
  const token = jwt.pack(data, secret)

  return { token, slug: null, slug_type: null }
}
